import { scrollToId } from "@/lib/scroll";

export default function Footer() {
    return (
        <footer className="border-t border-white/10 bg-navy-deep px-6 pb-10 pt-20 md:px-12" data-testid="main-footer">
            <div className="mx-auto max-w-[1440px]">
                <div className="grid grid-cols-1 gap-12 md:grid-cols-3">
                    <div>
                        <div className="flex items-center gap-3">
                            <span className="flex h-12 w-12 items-center justify-center overflow-hidden rounded-full border border-gold/60 bg-white">
                                <img src="/logo.jpg" alt="Logo AS Consulting S.A.S." className="h-full w-full object-contain" />
                            </span>
                            <span className="font-display text-xl font-semibold tracking-tight">AS Consulting S.A.S.</span>
                        </div>
                        <p className="mt-6 max-w-xs text-sm leading-relaxed text-[#9CA3AF]">
                            Contabilidad, impuestos y revisoría fiscal para PYMES en Colombia.
                        </p>
                        <p className="mt-6 text-xs uppercase tracking-[0.2em] text-[#9CA3AF]" data-testid="footer-nit">
                            NIT 901.847.225-4
                        </p>
                    </div>

                    <div>
                        <p className="mb-6 text-[10px] uppercase tracking-[0.3em] text-gold">Contacto</p>
                        <ul className="space-y-4 text-sm text-[#9CA3AF]">
                            <li data-testid="footer-address">Cra. 5 #22-78, San Nicolás<br />Cali, Valle del Cauca, Colombia</li>
                            <li>
                                <a href="https://wa.me/573043961777" target="_blank" rel="noopener noreferrer" className="transition-colors duration-300 hover:text-gold" data-testid="footer-whatsapp">
                                    WhatsApp: +57 304 396 1777
                                </a>
                            </li>
                            <li>
                                <a href="mailto:gerencia@asconsultingsas.com" className="transition-colors duration-300 hover:text-gold" data-testid="footer-email">
                                    gerencia@asconsultingsas.com
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <p className="mb-6 text-[10px] uppercase tracking-[0.3em] text-gold">Legal</p>
                        <p className="text-sm leading-relaxed text-[#9CA3AF]" data-testid="footer-data-policy">
                            Aviso de tratamiento de datos personales: la información
                            recolectada a través de este sitio se trata conforme a la
                            Ley 1581 de 2012 y el Decreto 1377 de 2013, únicamente para
                            atender solicitudes de asesoría.
                        </p>
                        <button
                            onClick={() => scrollToId("servicios")}
                            className="mt-6 text-sm text-gold underline-offset-4 transition-colors duration-300 hover:text-gold-soft hover:underline"
                            data-testid="footer-services-link"
                        >
                            Conocer nuestros servicios
                        </button>
                    </div>
                </div>

                <div className="mt-16 flex flex-col gap-3 border-t border-white/10 pt-8 text-[11px] uppercase tracking-[0.2em] text-[#9CA3AF]/60 sm:flex-row sm:items-center sm:justify-between">
                    <span data-testid="footer-copyright">© 2026 AS Consulting S.A.S. · Todos los derechos reservados</span>
                    <span>Cali · Valle del Cauca · Colombia</span>
                </div>
            </div>
        </footer>
    );
}
